import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import adminApiClient from "../../../api/admin";

const IGNORED_CLOCK_ERRORS_KEY = "ignoredClockErrors";

export const useIgnoredClockErrors = (version: number | null) => {
  return useQuery({
    queryKey: [IGNORED_CLOCK_ERRORS_KEY, version],
    queryFn: () => adminApiClient.getIgnoredClockErrors(version!),
    enabled: version != null,
  });
};

export const useCreateIgnoredClockError = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: {
      errorMessage: string;
      method: string;
      class: string;
      version: number;
      clockId?: string | null;
    }) => adminApiClient.createIgnoredClockError(data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [IGNORED_CLOCK_ERRORS_KEY],
      });
    },
  });
};

export const useSoftDeleteIgnoredClockError = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => adminApiClient.softDeleteIgnoredClockError(id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [IGNORED_CLOCK_ERRORS_KEY],
      });
    },
  });
};

export const useRestoreIgnoredClockError = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => adminApiClient.restoreIgnoredClockError(id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [IGNORED_CLOCK_ERRORS_KEY],
      });
    },
  });
};
